"use client";
import { useInView } from "react-intersection-observer";
import { AnimatedListDemo } from "../page/AnimatedList";
import { useTranslation } from 'react-i18next';

// Define types for your translations
type WorkTranslations = {
  title: string;
  intro: string;
  problems: string[];
  alternativeTitle: string;
  benefits: string[];
};

const Work = () => {
  const { ref } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });
  
  const { t } = useTranslation();
  
  // Get translations with proper typing
  const translations = t('work', { returnObjects: true }) as WorkTranslations;

  return (
    <section id="usecase" ref={ref} className='md:container min-w-[300px] sm:min-w-[450px] min-h-fit bg-white-bg rounded text-black'>
      <div className='flex p-3 md:p-8'>
        <div className='flex flex-col md:flex-row heading flex-wrap w-full'> {/* Changed here */}
          <div className='flex flex-col uppercase gap-4 text-left items-start justify-center w-full md:w-1/2'> {/* Changed here */}
            <h1 className='text-xl md:text-3xl font-primary sm:text-center'>
              {translations.title}
            </h1>
            <ul className='text-[14px] md:text-[18px] font-secondary leading-8'>
              <li className="font-bold">{translations.intro}</li>
              {translations.problems.map((problem: string, index: number) => (
                <li key={index}> ❌ {problem}</li>
              ))}
            </ul>
            <h1 className='text-xl md:text-3xl font-primary sm:text-center'>
              {translations.alternativeTitle}
            </h1>
            <ul className='text-[14px] md:text-[18px] leading-8 font-secondary'>
              {translations.benefits.map((benefit: string, index: number) => (
                <li key={index}> ✅ {benefit}</li>
              ))}
            </ul>
          </div>
          <div className='flex flex-col text-left items-center justify-center w-full md:w-1/2 mt-4 md:mt-0'> {/* Changed here */}
            <AnimatedListDemo />
          </div>
        </div>
      </div>
      <hr className='w-full'></hr>
    </section>
  );
};

export default Work;